/**
 * 画面の中のまとまり(カード)。見出し・補足・右上の操作・本文。業務ロジックは持たない。
 * ダッシュボードの各セクションや、集計表を包む枠に使う。
 */
import { Fragment, type ReactNode } from 'react';

/**
 * 注記の中の `**〜**` を太字にする(文字列で渡されたときだけ)。
 * 注記は「どこを見てほしいか」を1か所だけ強めたいことが多いので、書く側は文字列のままでよいようにする
 */
function withBold(note: ReactNode): ReactNode {
  if (typeof note !== 'string' || !note.includes('**')) return note;
  return note.split('**').map((part, i) => (i % 2 === 1 ? <b key={i}>{part}</b> : <Fragment key={i}>{part}</Fragment>));
}

export default function Panel({
  title,
  meta,
  actions,
  toolbar,
  note,
  children,
  className,
  id,
}: {
  /** ページ内リンク(#〜)の行き先にするとき(2026-09-22 追加) */
  id?: string;
  title?: ReactNode;
  /** 見出しの右の補足(期間・件数など) */
  meta?: ReactNode;
  /** 右上の操作 */
  actions?: ReactNode;
  /** 見出しの下の絞り込み・切り替えの行 */
  toolbar?: ReactNode;
  /** 本文の下の注記 */
  note?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section id={id} className={`ui-panel${className ? ` ${className}` : ''}`}>
      {(title || meta || actions) && (
        <div className="ui-panel-head">
          {title && <h2 className="ui-panel-title">{title}</h2>}
          {meta && <span className="ui-panel-meta">{meta}</span>}
          {actions && <div className="ui-panel-actions">{actions}</div>}
        </div>
      )}
      {toolbar && <div className="ui-panel-toolbar">{toolbar}</div>}
      <div className="ui-panel-body">{children}</div>
      {note && <p className="ui-panel-note">{withBold(note)}</p>}
    </section>
  );
}
